import { connect } from 'react-redux'
import at from 'lodash/at'

import { loadLocations } from '../../actions/locations'

import Select from '../../components/forms/redux-single-select'

function mapStateToProps (state, ownProps) {

  const locations = ownProps.useAllLocations ? Object.values(state.allLocations || {}): at( state.locations, state.pagination.locations.ids || [])

  locations.sort((a, b) => {
    // Use localeCompare for robust, correct alphabetical string comparison
    // We add defensive checks for name existence, though unlikely with Redux data
    return (a.name || '').localeCompare(b.name || '')
  })

  const options = locations.map(location => ({
    value: location.id,
    label: location.name
  }))

  return {
    options
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onMenuScrollToBottom () {
      dispatch(loadLocations(true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)



// WEBPACK FOOTER //
// ./src/containers/forms/location-selector-container.js